import axios, { AxiosResponse } from 'axios';
import { IClaim } from '../model/search.model';
import { IClaimDocs } from '../model/claim.model';

export interface IClaimApi {
  getClaimByClient(client: IClaim): Promise<AxiosResponse<any>>;
  getclaim(claimNumber: string): Promise<AxiosResponse<any>>;
}

export class ClaimApi implements IClaimApi {
  async getClaimByClient(client: IClaim): Promise<AxiosResponse<any>> {
    return axios.post('api/claims/getClientsClaims', client);
  }

  async getClaimsClientsForActiveSubscription(): Promise<AxiosResponse<any>> {
    return axios.get('api/claims/getClaimsClientsForActiveSubscription');
  }

  // ok
  async getclaim(claimNumber: string): Promise<AxiosResponse<any>> {
    return axios.get(`/api/claims/getclaimbyNumber`, { params: { claimNumber } });
  }

  // ok
  async getPaperAndDocument(subscriptionNumber: string, claimNumber: string): Promise<AxiosResponse<any>> {
    return axios.get('api/document/getPapersAndDocument/' + subscriptionNumber + '/' + claimNumber);
  }

  // ok
  async getClaimSubscription(subscriptionNumber: string): Promise<AxiosResponse<any>> {
    return axios.get('api/contract/getSubscription/' + subscriptionNumber);
  }

  // ok
  async getClaimEvent(entityType: string, number: string): Promise<AxiosResponse<any>> {
    return axios.get(`/api/event/getEvent`, { params: { entityType, number } });
  }

  // ok
  async getBenefit(claimNumber: string): Promise<AxiosResponse<any>> {
    return axios.get('api/logistical/getBenefit/' + claimNumber);
  }

  async getclaimbyClaimNumberAndSubscription(claimNumber: string): Promise<AxiosResponse<any>> {
    return axios.get(`/api/claims/getclaimbyClaimNumberAndSubscription`, { params: { claimNumber } });
  }

  async uploadClaimDocs(claim: IClaimDocs): Promise<AxiosResponse<any>> {
    return axios.put('api/contact/createContact', claim);
  }

  async getclaimsListBySubscriptionNumber(subscriptionNumber: string): Promise<AxiosResponse<any>> {
    return axios.get('api/claims/getclaimsListBySubscriptionNumber', { params: { subscriptionNumber } });
  }

  async declarerSinistre(subscriptionNumber: string): Promise<AxiosResponse<any>> {
    return axios.get('/api/claims/declareSinistre', { params: { subscriptionNumber } });
  }
}
